import { useCallback } from 'react';
import { ActivityIcon, EventIcon, PollIcon, PostIcon, WithingsOrderPostIcon } from 'ui';

export type PostType = 'activity' | 'event' | 'poll' | 'post' | 'withings_order_post';

export const useHeaderPostImage = () =>
  useCallback((postType: PostType) => {
    switch (postType) {
      case 'activity':
        return <ActivityIcon size="middle" type="primary" />;
      case 'event':
        return <EventIcon size="middle" type="primary" />;
      case 'poll':
        return <PollIcon size="middle" type="primary" />;
      case 'post':
        return <PostIcon size="middle" type="primary" />;
      case 'withings_order_post':
        return <WithingsOrderPostIcon size="middle" type="primary" />;
    }
  }, []);
